import { ElementRef, OnInit, OnDestroy, } from '@angular/core';
var CsAgGridPopoverDetailRendererComponent = /** @class */ (function () {
    function CsAgGridPopoverDetailRendererComponent(el) {
        this.el = el;
        this.popupEl = null;
        this.popupHtml = '';
        this.showCommonFile = true;
    }
    CsAgGridPopoverDetailRendererComponent.prototype.ngOnInit = function () {
        this.data = this.params.data;
        if (this.params.activity) {
            this.showCommonFile = false;
        }
    };
    CsAgGridPopoverDetailRendererComponent.prototype.onMouseEnter = function (event) {
        var content = this.data.recordType.toLowerCase();
        if (content !== 'job' && content !== 'opportunity')
            return;
        if (!this.popupEl) {
            // Call the API to fetch popup content when opening the popover
            if (this.params.popUpDetail) {
                this.popupHtml = this.params.popUpDetail(this.params.data);
            }
            this.popupEl = document.createElement('div');
            this.popupEl.classList.add('hover-popup-sched');
            this.popupEl.innerHTML = this.popupHtml;
            document.body.appendChild(this.popupEl);
        }
        var rect = event.target.getBoundingClientRect();
        var popupRect = this.popupEl.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var top = rect.top + rect.height / 2 + window.scrollY - popupRect.height / 2;
        if (top < window.scrollY) {
            top = window.scrollY + 10;
        }
        if (top + popupRect.height > window.scrollY + viewportHeight) {
            top = window.scrollY + viewportHeight - popupRect.height - 10; // Add padding from the bottom
        }
        this.popupEl.style.position = 'absolute';
        this.popupEl.style.top = top + "px";
        this.popupEl.style.left = rect.right + 10 + window.scrollX + "px";
        this.popupEl.style.zIndex = '9999';
        var arrowEl = this.popupEl.querySelector('.arrow-left-sched');
        if (arrowEl) {
            var arrowOffset = event.clientY - top;
            arrowEl.style.top = arrowOffset + "px";
        }
    };
    CsAgGridPopoverDetailRendererComponent.prototype.onMouseLeave = function () {
        if (this.popupEl) {
            this.popupEl.remove();
            this.popupEl = null;
        }
    };
    CsAgGridPopoverDetailRendererComponent.prototype.ngOnDestroy = function () {
        if (this.popupEl) {
            this.popupEl.remove();
            this.popupEl = null;
        }
    };
    return CsAgGridPopoverDetailRendererComponent;
}());
export { CsAgGridPopoverDetailRendererComponent };
